module.exports = __webpack_public_path__ + "static/img/banner-fixed4.3773310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-fixed4.jpg
// module id = Bw/Q
// module chunks = 1